import http from "../Services/http-common";

const CaptchaDataService = {
    verifyCaptcha: async (token) => {
        try {
            const response = await http.post(
                "/captcha/verify",
                { token }                 
            );

            return response.data;
        } catch (error) {
            console.error("CAPTCHA verification failed", error);
            return error.response?.data ?? { isValid: false };
        }
    }
};

export default CaptchaDataService;
